<ng-container *ngIf="!sending">
	<div class="tb-controls-wrapper">
		<div class="tb-controls-panel">
			<div class="tb-toolbar tb-toolbar--r1">
				<div class="tb-panel__exports" aria-label="Export">
					<button type="button" class="btn btn-success btn-sm" (click)="exportXls();" title="Excel"><i class="fa fa-file-excel-o"></i></button>
					<a href="{{this.arlink.apiServer.baseUrl}}{{this.arlink.apiServer.arTrialLink}}{{summary_details.value}}" class="btn btn-danger btn-sm" title="PDF"><i class="fa fa-file-pdf-o"></i></a>
				</div>
				<mat-form-field appearance="outline" class="tb-field tb-field--view" subscriptSizing="dynamic">
					<mat-label>View</mat-label>
					<mat-select [formControl]="summary_details">
						<mat-option *ngFor="let k of summary_or_details" [value]="k.value">
							{{ k.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--search" subscriptSizing="dynamic">
					<mat-label>Search</mat-label>
					<input matInput type="search" autocomplete="off" [(ngModel)]="toolbarSearchText" (ngModelChange)="onToolbarSearchChange()" placeholder="Name, #, terms…" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--filter" subscriptSizing="dynamic">
					<mat-label>Salesman</mat-label>
					<mat-select multiple [(ngModel)]="filterSalesmanCodes" (selectionChange)="applyFilters()" placeholder="All" appSelectAll>
						<mat-option *ngFor="let s of salesmanOptions" [value]="s.code">{{ s.name }}<span *ngIf="s.name !== s.code"> ({{ s.code }})</span></mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--filter" subscriptSizing="dynamic">
					<mat-label>Terms</mat-label>
					<mat-select multiple [(ngModel)]="filterTermsCodes" (selectionChange)="applyFilters()" placeholder="All" appSelectAll>
						<mat-option *ngFor="let t of termsOptions" [value]="t.code">{{ t.label }}<span *ngIf="t.label !== t.code"> ({{ t.code }})</span></mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field *ngIf="brandFilterEnabled" appearance="outline" class="tb-field tb-field--filter" subscriptSizing="dynamic">
					<mat-label>Brand</mat-label>
					<mat-select multiple [(ngModel)]="filterBrandIds" (selectionChange)="applyFilters()" placeholder="All" appSelectAll
						matTooltip="Show customers with open lines for these brands. Balances stay whole — a mixed invoice is tagged with every brand on it.">
						<mat-option *ngFor="let b of brandOptions" [value]="b.code">{{ b.label }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--filter tb-field--filter-narrow" subscriptSizing="dynamic">
					<mat-label>Card on file</mat-label>
					<mat-select [(ngModel)]="cardOnFileFilter" (selectionChange)="applyFilters()">
						<mat-option value="all">All</mat-option>
						<mat-option value="yes">Yes</mat-option>
						<mat-option value="no">No</mat-option>
					</mat-select>
				</mat-form-field>
				<div class="tb-toolbar__end">
					<span class="tb-count-pill">{{ gridRows.length }} customers</span>
					<div class="tb-neg-balance" title="Show or hide customers with negative AR balance">
						<span class="tb-neg-balance__label">Neg. balance</span>
						<span class="tb-neg-balance__hint" [class.tb-neg-balance__hint--on]="!includeNegativeBalances">Hide</span>
						<mat-slide-toggle [(ngModel)]="includeNegativeBalances" (ngModelChange)="applyFilters()" color="primary"></mat-slide-toggle>
						<span class="tb-neg-balance__hint" [class.tb-neg-balance__hint--on]="includeNegativeBalances">Show</span>
					</div>
					<button *ngIf="showToolbarRefresh" mat-stroked-button color="primary" type="button" class="tb-btn-refresh"
						[disabled]="toolbarRefreshDisabled"
						(click)="emitToolbarRefresh()">
						<mat-icon>refresh</mat-icon>
						Refresh
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<div class="listitem row border-bottom pl-1 pr-1 ml-1 mr-1">
	<ng-container *ngIf="sending">
		<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</ng-container>
	<div class="table">
		<ng-container>
			<div class="table table-fluid w-100 tb-table-wrap" #printTable>
			  <table class="table table-fluid w-100 tb-main-table">
				<thead class="thead-dark">
				  <tr>
					<th *ngIf="summary_details.value" class="sticky-header text-center donotprint tb-col-expand" scope="col" matTooltip="Summary only: show this customer’s lines below (one row at a time)">Lines</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('name')" [attr.aria-sort]="sortIndicator('name') === 'asc' ? 'ascending' : (sortIndicator('name') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Name</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('name') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('debtorno')" [attr.aria-sort]="sortIndicator('debtorno') === 'asc' ? 'ascending' : (sortIndicator('debtorno') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Customer #</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('debtorno') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th *ngIf="showAccountOverviewAction" class="sticky-header text-center tb-col-overview donotprint" scope="col">Account</th>
					<th *ngIf="showPaymentAction" class="sticky-header text-center tb-col-pay donotprint" scope="col">Pay</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('typename')" [attr.aria-sort]="sortIndicator('typename') === 'asc' ? 'ascending' : (sortIndicator('typename') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Customer Type</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('typename') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('terms')" [attr.aria-sort]="sortIndicator('terms') === 'asc' ? 'ascending' : (sortIndicator('terms') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Terms</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('terms') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th *ngIf="brandFilterEnabled" class="sticky-header tb-sortable" scope="col" (click)="setSort('brands_display')" [attr.aria-sort]="sortIndicator('brands_display') === 'asc' ? 'ascending' : (sortIndicator('brands_display') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Brand</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('brands_display') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('salesperson')" [attr.aria-sort]="sortIndicator('salesperson') === 'asc' ? 'ascending' : (sortIndicator('salesperson') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Salesperson</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('salesperson') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header text-center tb-sortable" scope="col" (click)="setSort('card_on_file')" [attr.aria-sort]="sortIndicator('card_on_file') === 'asc' ? 'ascending' : (sortIndicator('card_on_file') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Card on file</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('card_on_file') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('creditlimit')" [attr.aria-sort]="sortIndicator('creditlimit') === 'asc' ? 'ascending' : (sortIndicator('creditlimit') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Credit</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('creditlimit') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('reasondescription')" [attr.aria-sort]="sortIndicator('reasondescription') === 'asc' ? 'ascending' : (sortIndicator('reasondescription') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Status</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('reasondescription') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('balance')" [attr.aria-sort]="sortIndicator('balance') === 'asc' ? 'ascending' : (sortIndicator('balance') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Balance</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('balance') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('future')" [attr.aria-sort]="sortIndicator('future') === 'asc' ? 'ascending' : (sortIndicator('future') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Future</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('future') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('current')" [attr.aria-sort]="sortIndicator('current') === 'asc' ? 'ascending' : (sortIndicator('current') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Current</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('current') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('due')" [attr.aria-sort]="sortIndicator('due') === 'asc' ? 'ascending' : (sortIndicator('due') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">30 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('due') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue')" [attr.aria-sort]="sortIndicator('overdue') === 'asc' ? 'ascending' : (sortIndicator('overdue') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">60 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue1')" [attr.aria-sort]="sortIndicator('overdue1') === 'asc' ? 'ascending' : (sortIndicator('overdue1') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">90 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue1') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue2')" [attr.aria-sort]="sortIndicator('overdue2') === 'asc' ? 'ascending' : (sortIndicator('overdue2') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">120 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue2') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
				  </tr>
				</thead>
				<tbody>
				  <ng-container *ngFor="let result of gridRows; let i = index">
					<tr [class.tb-row--open]="summary_details.value && isRowDetailExpanded(result)">
					  <td *ngIf="summary_details.value" class="text-center donotprint tb-col-expand">
						<button *ngIf="hasExpandableLineDetails(result)" type="button" mat-icon-button class="tb-expand-btn"
							(click)="toggleRowDetailExpand(result, $event)"
							[attr.aria-expanded]="isRowDetailExpanded(result)"
							matTooltip="{{ isRowDetailExpanded(result) ? 'Hide' : 'Show' }} line items">
							<mat-icon>{{ isRowDetailExpanded(result) ? 'expand_less' : 'expand_more' }}</mat-icon>
						</button>
					  </td>
					  <td>
						<a class="tb-cell-link" [routerLink]="['/customers/view', result.debtorno]" [queryParams]="customerViewQueryForRow(result)">{{ result.name }}</a>
					  </td>
					  <td>
						<a class="tb-cell-link tb-id-badge" [routerLink]="['/customers/view', result.debtorno]" [queryParams]="customerViewQueryForRow(result)">{{ result.debtorno }}</a>
					  </td>
					  <td *ngIf="showAccountOverviewAction" class="text-center tb-col-overview donotprint">
						<button type="button" mat-icon-button class="tb-icon-action" (click)="emitAccountOverview(result, $event)"
							matTooltip="Balance, saved cards, open AR">
							<mat-icon>account_balance_wallet</mat-icon>
						</button>
					  </td>
					  <td *ngIf="showPaymentAction" class="text-center tb-col-pay donotprint">
						<button type="button" mat-icon-button class="tb-icon-action" (click)="emitTakePayment(result, $event)"
							matTooltip="Take payment">
							<mat-icon>payment</mat-icon>
						</button>
					  </td>
					  <td>{{ result.typename }}</td>
					  <td>{{ customerTermsSummary(result) }}</td>
					  <td *ngIf="brandFilterEnabled" class="tb-col-brand">{{ customerBrandsSummary(result) }}</td>
					  <td>{{ salespersonDisplay(result) }}</td>
					  <td class="text-center text-nowrap">{{ result.card_on_file || '—' }}</td>
					  <td>{{ result.creditlimit | currency }}</td>
					  <td>{{ result.reasondescription }}</td>
					  <td class="text-right tb-num">{{ result.balance | currency }}</td>
					  <td class="text-right tb-num">{{ result.future | currency }}</td>
					  <td class="text-right tb-num">{{ result.current | currency }}</td>
					  <td class="text-right tb-num">{{ result.due | currency }}</td>
					  <td class="text-right tb-num">{{ result.overdue | currency }}</td>
					  <td class="text-right tb-num" [class.tb-num--warn]="isPositiveAmount(result.overdue1)">{{ result.overdue1 | currency }}</td>
					  <td class="text-right tb-num" [class.tb-num--late]="isPositiveAmount(result.overdue2)">{{ result.overdue2 | currency }}</td>
					</tr>
					<ng-container *ngIf="detailLinesVisibleForRow(result)">
					  <tr class="tb-detail-row">
						<td [attr.colspan]="trialBalanceColCount" class="p-0 border-0">
						  <div class="tb-detail-panel">
							<div class="tb-detail-panel__head donotprint">
								<mat-icon class="tb-detail-panel__head-icon" aria-hidden="true">receipt_long</mat-icon>
								<span class="tb-detail-panel__head-text">Open AR lines — <strong>{{ result.name }}</strong></span>
								<span class="tb-detail-panel__head-meta">{{ result.debtorno }}</span>
								<span class="tb-detail-panel__head-meta" *ngIf="brandFilterActive">
									brand-filtered — {{ visibleDetailBalance(result) | currency }} of {{ result.balance | currency }} total AR
								</span>
								<button *ngIf="showPaymentAction" mat-flat-button color="accent" class="tb-detail-pay-btn" (click)="emitTakePayment(result, $event)">
									<mat-icon>payment</mat-icon>
									Take Payment
								</button>
							</div>
							<div class="tb-detail-panel__stats donotprint">
								<div class="tb-detail-stat">
									<span class="tb-detail-stat__label">Balance</span>
									<span class="tb-detail-stat__value">{{ result.balance | currency }}</span>
								</div>
								<div class="tb-detail-stat">
									<span class="tb-detail-stat__label">30 Day</span>
									<span class="tb-detail-stat__value">{{ result.due | currency }}</span>
								</div>
								<div class="tb-detail-stat">
									<span class="tb-detail-stat__label">90 Day</span>
									<span class="tb-detail-stat__value" [class.tb-detail-stat__value--warn]="isPositiveAmount(result.overdue1)">{{ result.overdue1 | currency }}</span>
								</div>
								<div class="tb-detail-stat">
									<span class="tb-detail-stat__label">120 Day</span>
									<span class="tb-detail-stat__value" [class.tb-detail-stat__value--late]="isPositiveAmount(result.overdue2)">{{ result.overdue2 | currency }}</span>
								</div>
							</div>
							<div class="tb-detail-panel__body">
							  <div class="table-responsive tb-detail-scroll">
								<table class="table table-sm mb-0 tb-detail-table">
								  <thead>
									<tr class="d-none">
										<th>{{result.name}}</th>
										<th>{{result.debtorno}}</th>
									</tr>
									<tr>
									  <th scope="col">Type</th>
									  <th scope="col">Invoice</th>
									  <th scope="col">Order</th>
									  <th scope="col">Tran date</th>
									  <th scope="col">Due date</th>
									  <th scope="col">Terms</th>
									  <th *ngIf="brandFilterEnabled" scope="col">Brand</th>
									  <th scope="col" class="text-right">Balance</th>
									  <th scope="col" class="text-right">Future</th>
									  <th scope="col" class="text-right">Current</th>
									  <th scope="col" class="text-right">30d</th>
									  <th scope="col" class="text-right">60d</th>
									  <th scope="col" class="text-right">90d</th>
									  <th scope="col" class="text-right">120d</th>
									</tr>
								  </thead>
								  <tbody>
									<ng-container *ngFor="let det of visibleDetailLines(result); let b = index">
									  <tr>
										<td>{{ det.typename }}</td>
										<td class="text-nowrap">{{ det.transno }}</td>
										<td class="text-nowrap">{{ det.order_ }}</td>
										<td class="text-nowrap">{{ formatDetailTranDate(det) }}</td>
										<td class="text-nowrap">{{ formatDetailDueDate(det) }}</td>
										<td>{{ detailTermCode(det) }}</td>
										<td *ngIf="brandFilterEnabled" class="tb-col-brand">{{ detailBrands(det) }}</td>
										<td class="text-right tb-num">{{ det.balance | currency }}</td>
										<td class="text-right tb-num">{{ det.future | currency }}</td>
										<td class="text-right tb-num">{{ det.current | currency }}</td>
										<td class="text-right tb-num">{{ det.due | currency }}</td>
										<td class="text-right tb-num">{{ det.overdue | currency }}</td>
										<td class="text-right tb-num" [class.tb-num--warn]="isPositiveAmount(det.overdue1)">{{ det.overdue1 | currency }}</td>
										<td class="text-right tb-num" [class.tb-num--late]="isPositiveAmount(det.overdue2)">{{ det.overdue2 | currency }}</td>
									  </tr>
									</ng-container>
								  </tbody>
								</table>
							  </div>
							</div>
						  </div>
						</td>
					  </tr>
					</ng-container>
				  </ng-container>
				  <tr *ngIf="!gridRows.length" class="tb-empty-row">
					<td [attr.colspan]="trialBalanceColCount" class="tb-empty-cell">
						<div class="tb-empty">
							<mat-icon class="tb-empty__icon">search_off</mat-icon>
							<span>{{ toolbarSearchText ? 'No customers match your search' : 'No customer balances to show' }}</span>
						</div>
					</td>
				  </tr>
				</tbody>
				<tfoot>
				  <tr class="tb-footer-row">
					<td *ngIf="summary_details.value" class="donotprint tb-col-expand"></td>
					<td [attr.colspan]="footerLabelColspan" class="tb-footer-label">Total</td>
					<td class="text-right tb-num tb-total-cell">{{ total_balance | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_future | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_current | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_due | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_overdue | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_overdue1 | currency }}</td>
					<td class="text-right tb-num tb-total-cell">{{ total_overdue2 | currency }}</td>
				  </tr>
				</tfoot>
			  </table>
			</div>
			<ng-container *ngIf="paginator_show">
				<mat-paginator class="tb-paginator" [pageSizeOptions]="[2000,3000]" showFirstLastButtons aria-label="select page" [hidePageSize]="paginator_show" [pageSize]="pageSize">
				</mat-paginator>
			</ng-container>
		</ng-container>
	</div>
</div>
